import { createTheme } from '@mui/material/styles'
import { PartnerPageData } from 'types/types'

export const getTheme = (page: { page: PartnerPageData }, isLandingPage: boolean) => {
  const theme = createTheme({
    palette: {
      primary: {
        main: '#343549',
      },
      secondary: {
        main: page.page?.secondary_text_color ?? '#00CEF3',
      },
      background: {
        default: isLandingPage
          ? page.page?.landing_bg_color
          : page.page?.background_color ?? '#EDEDED',
      },
      action: {
        disabledBackground: '#bdbdbd',
      },
    },
    typography: {
      fontFamily: page.page?.fonts.main_font.family,
      fontWeightMedium: 500,
      fontWeightRegular: 500,

      body1: {
        color: page.page?.base_game_text_color ?? '#353535',
      },
      body2: {
        color: page.page?.base_game_text_color ?? '#353535',
      },
    },

    components: {
      MuiStepLabel: {
        styleOverrides: {
          label: {
            fontFamily: `${page.page?.fonts.main_font.family}, sans-serif`,
          },
        },
      },
      MuiTableCell: {
        styleOverrides: {
          root: {
            color: page.page?.base_game_text_color ?? '#353535',
          },
        },
      },

      MuiButton: {
        styleOverrides: {
          root: {
            borderRadius: 8,
            boxShadow: '0px 10px 20px rgba(0, 0, 0, 0.1)',
          },
          containedPrimary: {
            color: page.page?.primary_button_text_color ?? '#353535',
            backgroundColor: page.page?.primary_button_color ?? '#00CEF3',
            '&:hover': {
              backgroundColor: page.page?.secondary_button_color ?? '#00CEF3',
            },
          },
        },
      },
      MuiFormControlLabel: {
        styleOverrides: {
          root: {
            '& .MuiCheckbox-root + .MuiFormControlLabel-label': {
              fontFamily: `${page.page?.fonts.secondary_font.family}, sans-serif`,
            },
          },
        },
      },
      MuiCheckbox: {
        styleOverrides: {
          root: {
            color: page.page?.secondary_text_color,
            '&.Mui-checked': {
              color: page.page?.secondary_text_color,
            },
          },
        },
      },
      MuiLinearProgress: {
        styleOverrides: {
          bar1Determinate: {
            backgroundColor: page.page?.game_page_second_header_color ?? '#00CEF3',
          },
        },
      },
      MuiTextField: {
        styleOverrides: {
          root: {
            '& label': {
              color: 'rgba(0,0,0,0.5)',
            },
          },
        },
      },
      MuiPaper: {
        styleOverrides: {
          elevation1: {
            boxShadow: '0px 10px 20px rgba(0, 0, 0, 0.1)',
          },
        },
      },
    },
  })

  theme.typography.h2 = {
    [theme.breakpoints.up('md')]: {
      fontSize: '3.375rem',
    },

    [theme.breakpoints.down('md')]: {
      fontSize: '2.5rem',
    },

    [theme.breakpoints.down('sm')]: {
      fontSize: '2rem',
    },
  }

  theme.typography.h3 = {
    [theme.breakpoints.up('md')]: {
      fontSize: '2.5rem',
    },

    [theme.breakpoints.down('md')]: {
      fontSize: '2rem',
    },

    [theme.breakpoints.down('sm')]: {
      fontSize: '1.5rem',
    },
  }

  theme.typography.h4 = {
    [theme.breakpoints.up('md')]: {
      fontSize: '2rem',
    },

    [theme.breakpoints.down('md')]: {
      fontSize: '1.5rem',
    },

    [theme.breakpoints.down('sm')]: {
      fontSize: '1.25rem',
    },
  }

  theme.typography.h5 = {
    [theme.breakpoints.up('md')]: {
      fontSize: '1.5rem',
    },

    [theme.breakpoints.down('md')]: {
      fontSize: '1.25rem',
    },

    [theme.breakpoints.down('sm')]: {
      fontSize: '1rem',
    },
  }
  return theme
}
